import React, { useEffect } from "react";
import styles from "./legal_info.module.css";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { BASE_URL, SHOP_NAME, COMPANY_SELLER } from "../../utils/constants";
import { Link, useLocation } from "react-router-dom";
import { getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { useSelector, useDispatch } from "react-redux";
import { getContacts, getSettings } from "../../services/selectors";
import { ROUTES_CONST } from "../../utils/constants";


const PersonalData = () => {

  const settings = useSelector(getSettings);
  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {window.scrollTo({ top: 0, left: 0 })}, []);

  const { email } = useSelector(getContacts).emails[0] || { email: COMPANY_SELLER.email };

  return (
    <main className="main">
      <h1 className="title title__left">
        {title}
      </h1>
      <ol className={styles.list_outer}>
        <li className={styles.item_outer}>
          Общие положения
          <ol className={styles.list}>
            <li className={styles.item}>
              Настоящая политика обработки персональных данных принята в соответствии
              с требованиями Федерального закона от 27.07.2006. №152-ФЗ «О персональных
              данных» и иными подзаконными нормативными актами и определяет порядок
              обработки персональных данных и меры по обеспечению их безопасности в&ensp;
              {settings.company_seller.name || COMPANY_SELLER.name} (далее — Оператор).
            </li>
            <li className={styles.item}>
              Обработка персональных данных осуществляется Оператором для заключения,
              исполнения, изменения гражданско-правовых договоров (поставки,
              купли-продажи, услуг, технической поддержки, счетов-договоров и иных),
              публичная оферта на которые размещена Оператором в сети Интернет на веб-сайте&ensp;
              <Link to={'/'} className={styles.link}>{settings.shop_name || SHOP_NAME}</Link>,
              и инициатором заключения которых является субъект персональных
              данных — Пользователь сайта, а также для передачи необходимой информации
              путем смс — уведомлений и (или) электронных сообщений Субъекту персональных
              данных.
            </li>
            <li className={styles.item}>
              Оператор ставит своей целью и условием осуществления своей деятельности
              соблюдение прав и свобод человека и гражданина при обработке его персональных
              данных, в том числе защиты прав на неприкосновенность частной жизни, личную
              и семейную тайну.
            </li>
            <li className={styles.item}>
              Настоящая политика Оператора в отношении обработки персональных данных
              (далее – Политика) применяется ко всей информации, которую Оператор может
              получить о посетителях веб-сайта&ensp;
              <Link to={'/'} className={styles.link}>{settings.shop_name || SHOP_NAME}</Link>
              , в том числе при регистрации на сайте, при внесении/изменении персональных
              данных, при использовании сервисов сайта, при заполнении форм обратной
              связи, при осуществлении платежей.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Основные понятия, используемые в Политике
          <ol className={styles.list}>
            <li className={styles.item}>
              Автоматизированная обработка персональных данных – обработка персональных
              данных с помощью средств вычислительной техники.
            </li>
            <li className={styles.item}>
              Блокирование персональных данных – временное прекращение обработки персональных
              данных (за исключением случаев, если обработка необходима для уточнения
              персональных данных).
            </li>
            <li className={styles.item}>
              Веб-сайт – совокупность графических и информационных материалов, а также
              программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет
              по сетевому адресу&ensp;<Link to={'/'} className={styles.link}>{BASE_URL}</Link>.
            </li>
            <li className={styles.item}>
              Информационная система персональных данных — совокупность содержащихся в
              базах данных персональных данных, и обеспечивающих их обработку информационных
              технологий и технических средств;
            </li>
            <li className={styles.item}>
              Обезличивание персональных данных — действия, в результате которых невозможно
              определить без использования дополнительной информации принадлежность
              персональных данных конкретному Пользователю или иному субъекту персональных
              данных.
            </li>
            <li className={styles.item}>
              Обработка персональных данных – любое действие (операция) или совокупность
              действий (операций), совершаемых с использованием средств автоматизации или
              без использования таких средств с персональными данными, включая сбор, запись,
              систематизацию, накопление, хранение, уточнение (обновление, изменение),
              извлечение, использование, обезличивание, блокирование, удаление, уничтожение
              персональных данных.
            </li>
            <li className={styles.item}>
              Согласие на передачу (распространение, предоставление, доступ) персональных
              данных третьим лицам и определение перечня и категорий таких данных
              осуществляется Пользователем отдельным разрешением.
            </li>
            <li className={styles.item}>
              Оператор – {settings.company_seller.name || COMPANY_SELLER.name},
              самостоятельно или совместно с другими лицами организующие и (или)
              осуществляющие обработку персональных данных, а также определяющие цели
              обработки персональных данных, состав персональных данных, подлежащих обработке,
              действия (операции), совершаемые с персональными данными;
            </li>
            <li className={styles.item}>
              Персональные данные – любая информация, относящаяся прямо или косвенно к
              определенному или определяемому Пользователю веб-сайта&ensp;
              <Link to={'/'} className={styles.link}>{settings.shop_name || SHOP_NAME}</Link>,
              достаточная для его идентификации независимо от того, является ли она
              достоверной и записана ли она на материальном носителе;
            </li>
            <li className={styles.item}>
              Оператор не осуществляет сбор биометрических персональных данных;
            </li>
            <li className={styles.item}>
              Пользователь – любое дееспособное физическое лицо - посетитель веб-сайта&ensp;
              <Link to={'/'} className={styles.link}>{settings.shop_name || SHOP_NAME}</Link>,
              предоставляющее Оператору свои персональные данные;
            </li>
            <li className={styles.item}>
              Предоставление персональных данных – действия Пользователя, направленные
              на раскрытие своих персональных данных определенному лицу или определенному
              кругу лиц;
            </li>
            <li className={styles.item}>
              Распространение персональных данных – любые действия, направленные на
              раскрытие персональных данных неопределенному кругу лиц (передача персональных
              данных) или на ознакомление с персональными данными неограниченного круга лиц,
              в том числе обнародование персональных данных в средствах массовой информации,
              размещение в информационно-телекоммуникационных сетях или предоставление
              доступа к персональным данным каким-либо иным способом;
            </li>
            <li className={styles.item}>
              Обработка персональных данных, разрешенных субъектом для распространения,
              осуществляется с соблюдением запретов и условий, предусмотренных ст. 10.1
              Федерального закона от 27.07.06г. №152-ФЗ «О защите персональных данных»;
            </li>
            <li className={styles.item}>
              Трансграничная передача персональных данных – передача персональных данных
              на территорию иностранного государства органу власти иностранного государства,
              иностранному физическому или иностранному юридическому лицу.
            </li>
            <li className={styles.item}>
              Уничтожение персональных данных – любые действия, в результате которых
              персональные данные уничтожаются безвозвратно с невозможностью дальнейшего
              восстановления содержания персональных данных в информационной системе
              персональных данных и (или) результате которых уничтожаются материальные
              носители персональных данных.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Оператор может обрабатывать следующие персональные данные Пользователя:
          <ol className={styles.list}>
            <li className={styles.item}>
              Фамилия, имя, отчество.
            </li>
            <li className={styles.item}>
              Адрес регистрации субъекта, адрес доставки товара.
            </li>
            <li className={styles.item}>
              Адрес электронной почты.
            </li>
            <li className={styles.item}>
              Номера телефонов.
            </li>
            <li className={styles.item}>
              Платежная информация (реквизиты кредитных карт Пользователя, банка).
            </li>
            <li className={styles.item}>
              Обезличенные данные о Пользователе (в том числе, IP-адрес, файлы
              «cookie», информация о браузере Пользователя (или иной программе)
              и иная подобная информация, которая автоматически передается с помощью
              сервисов интернет-статистики (Яндекс Метрика и Гугл Аналитика и других).
            </li>
            <li className={styles.item}>
              Информация, указываемая Пользователем в корреспонденции с Оператором.
            </li>
            <p className={styles.text}>
              Вышеперечисленные данные далее по тексту объединены общим понятием
              Персональные данные, которые хранятся Оператором в электронном виде в базах
              данных информационной системы и на материальных носителях.
            </p>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Цели обработки персональных данных
          <ol className={styles.list}>
            <li className={styles.item}>
              Цель обработки персональных данных Пользователя — идентификация стороны
              при заключении, исполнении и прекращении гражданско-правовых договоров
              (в том числе заключаемых путем присоединения к публичной оферте); обратная
              связь и информирование Пользователя товарах, о ходе исполнения договоров
              и других условиях коммерческого взаимодействия посредством телефонной связи,
              отправки электронных писем и (или) смс-сообщений; обработка платежей
              Пользователя; предоставление доступа Пользователя к сервисам, клиентской и
              технической поддержке, а также к информации и/или материалам, содержащимся
              на веб-сайте.
            </li>
            <li className={styles.item}>
              Оператор имеет право направлять Пользователю уведомления о новых продуктах
              и услугах, специальных предложениях и различных событиях. Пользователь всегда
              может отказаться от получения информационных сообщений, направив Оператору
              письмо на адрес электронной почты&ensp;
              <Link to={`mailto:${email}`} className={styles.link}>{email}</Link>&ensp;
              с пометкой «Отказ от
              уведомлениях о новых продуктах и услугах и специальных предложениях».
            </li>
            <li className={styles.item}>
              Оператор обрабатывает персональные данные с целью предоставления услуг по
              технической поддержке, для обработки запросов и заявок Пользователя, а
              также в целях совершенствования работы Оператора.
            </li>
            <li className={styles.item}>
              Обезличенные данные Пользователей, собираемые с помощью сервисов
              интернет-статистики, служат для сбора информации о действиях Пользователей
              на сайте, улучшения качества сайта и его содержания.
            </li>
            <li className={styles.item}>
              Статистика об IP-адресах всех посетителей обрабатывается, чтобы выявить и
              решить технические проблемы и проконтролировать законность проведения
              финансовых платежей.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Правовые основания обработки персональных данных
          <ol className={styles.list}>
            <li className={styles.item}>
              Оператор обрабатывает персональные данные Пользователя только в случае
              их заполнения и/или отправки Пользователем самостоятельно через специальные
              формы, расположенные на сайте&ensp;
              <Link to={'/'} className={styles.link}>{settings.shop_name || SHOP_NAME}</Link>.
            </li>
            <li className={styles.item}>
              Заполняя соответствующие формы и/или отправляя свои персональные данные
              Оператору, при условии активизации специального флажка «чекбокса» напротив
              текста Политики в отношении обработки персональных данных, размещенной на
              веб-сайте&ensp;
              <Link to={'/'} className={styles.link}>{settings.shop_name || SHOP_NAME}</Link>,
              Пользователь выражает свое конкретное, предметное, информированное,
              сознательное и однозначное согласие на обработку персональных данных.
            </li>
            <li className={styles.item}>
              Оператор не проверяет достоверность получаемой (собираемой) информации о
              Пользователях.
            </li>
            <li className={styles.item}>
              Оператор обрабатывает обезличенные данные о Пользователе в случае, если
              это разрешено в настройках браузера Пользователя (включено сохранение
              файлов «cookie» и использование технологии JavaScript).
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Порядок сбора, хранения, передачи и других видов обработки персональных данных
          <ol className={styles.list}>
            <li className={styles.item}>
              Процедура обработки может проводиться любым предусмотренным законодательством
              способом. В частности, автоматически либо без средств автоматизации.
            </li>
            <li className={styles.item}>
              Оператор осуществляет автоматизированную обработку персональных данных
              Пользователей с передачей по внутренней сети юридического лица, а также с
              передачей по сети Интернет.
            </li>
            <li className={styles.item}>
              Обработанные Оператором персональные данные Пользователя могут передаваться
              третьим лицам, в число которых входят курьерские службы, организации почтовой
              связи, операторы электросвязи. Делается это для того, чтобы выполнить заказ
              Пользователя, оставленный им на сайте Компании, и доставить товар по адресу.
              Согласие Пользователя на подобную передачу предусмотрено правилами политики сайта.
            </li>
            <li className={styles.item}>
              Персональные данные Пользователя могут быть переданы без согласия Пользователя
              следующим лицам: государственным органам, в том числе органам дознания и
              следствия, суда по их мотивированному запросу; контрагентам Оператора c целью
              выполнения договорных обязательств перед Пользователем; в иных случаях, прямо
              предусмотренных Законодательством.
            </li>
            <li className={styles.item}>
              В случае выявления неточностей в персональных данных, Пользователь может
              актуализировать их самостоятельно, путем направления Оператору уведомление на
              адрес электронной почты Оператора&ensp;
              <Link to={`mailto:${email}`} className={styles.link}>{email}</Link>&ensp;
              с пометкой «Актуализация персональных данных».
            </li>
            <li className={styles.item}>
              Срок обработки персональных данных является неограниченным. Пользователь может
              в любой момент отозвать свое согласие на обработку персональных данных,
              направив Оператору уведомление посредством электронной почты на электронный
              адрес Оператора&ensp;
              <Link to={`mailto:${email}`} className={styles.link}>{email}</Link>&ensp;
              с пометкой «Отзыв согласия на обработку персональных данных».
            </li>
            <li className={styles.item}>
              Оператор не осуществляет распространение персональных данных (любые действия,
              направленные на раскрытие персональных данных Пользователя неопределенному
              кругу лиц).
            </li>
            <li className={styles.item}>
              Нормативный срок хранения персональных данных, содержащихся на материальных
              носителях (УПД, акты выполненных работ, товарно-транспортные накладные и иные
              документы, связанные с реализацией гражданско-правовых договоров), а также
              порядок их уничтожения (утилизации) определяется в соответствии с
              законодательством о бухгалтерском учёте в Российской Федерации.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Трансграничная передача персональных данных
          <ol className={styles.list}>
            <li className={styles.item}>
              Оператор до начала осуществления трансграничной передачи персональных данных
              обязан направить уведомление в Роскомнадзор о намерении передать персональные
              данные за границу, а также убедиться в том, что иностранным государством, на
              территорию которого предполагается осуществлять передачу персональных данных,
              обеспечивается надежная защита прав субъектов персональных данных.
            </li>
            <li className={styles.item}>
              Трансграничная передача персональных данных на территории иностранных
              государств, не отвечающих вышеуказанным требованиям, может осуществляться
              только в случае наличия согласия в письменной форме субъекта персональных
              данных на трансграничную передачу его персональных данных и/или исполнения
              договора, стороной которого является субъект персональных данных.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Защита персональных данных
          <ol className={styles.list}>
            <li className={styles.item}>
              Оператор обеспечивает внутреннюю и внешнюю защиту персональных данных.
            </li>
            <li className={styles.item}>
              Для обеспечения внутренней защиты Оператор ограничивает состав работников,
              функциональные обязанности которых требуют доступа к персональным данным
              Пользователей, обеспечивает хранение и учёт материальных носителей в отдельном
              помещении (архиве), обеспечивающем защиту от несанкционированного доступа.
              Электронно-вычислительные машины, средствами которых осуществляется работа с
              персональными данными, имеет парольную систему доступа и защиту от внешнего
              доступа.
            </li>
            <li className={styles.item}>
              В число лиц, имеющих доступ к персональным данным Пользователей, входят
              штатные сотрудники Оператора или его аффилированных лиц, непосредственно
              участвующие в реализации гражданско-правовых договоров с физическими лицами.
            </li>
            <li className={styles.item}>
              Для обеспечения внешней защиты персональных данных используются технические
              средства и системы антивирусной защиты.
            </li>
            <li className={styles.item}>
              Безопасность персональных данных, которые обрабатываются Оператором,
              обеспечивается путем реализации правовых, организационных и технических мер,
              необходимых для выполнения в полном объеме требований действующего
              законодательства в области защиты персональных данных.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Уведомление об инцидентах.
          <ol className={styles.list}>
            <li className={styles.item}>
              Инцидент — это утечка персональных данных (неправомерная или случайная
              передача). В течение 24 часов Оператор уведомляет Роскомнадзор о произошедшем
              инциденте, его предполагаемых причинах и последствиях. В течение 72 часов
              Оператор проводит расследование инцидента в соответствии с внутренним
              регламентом расследования и сообщает контролирующему органу о его результатах.
            </li>
          </ol>
        </li>
        <li className={styles.item_outer}>
          Заключительные положения
          <ol className={styles.list}>
            <li className={styles.item}>
              Пользователь может получить любые разъяснения по интересующим вопросам,
              касающимся обработки его персональных данных, обратившись к Оператору с
              помощью электронной почты&ensp;
              <Link to={`mailto:${email}`} className={styles.link}>{email}</Link>&ensp;.
              Оператор обязан обработать запрос и ответить в срок, не превышающий 10 дней.
            </li>
            <li className={styles.item}>
              Если по тем или иным причинам одно или несколько положений Политики будут
              признаны недействительными или не имеющими юридической силы, это не оказывает
              влияния на действительность или применимость остальных положений Политики.
            </li>
            <li className={styles.item}>
              В данном документе будут отражены любые изменения политики обработки
              персональных данных Оператором. Политика действует бессрочно до замены
              ее новой версией.
            </li>
            <li className={styles.item}>
              Актуальная версия Политики в свободном доступе расположена в сети Интернет
              по адресу&ensp;
              <Link to={'/personal-data'} className={styles.link}>{settings.shop_name || SHOP_NAME}</Link>.
            </li>
            <li className={styles.item}>
              Обращаясь за информацией на сайт&ensp;
              <Link to={'/'} className={styles.link}>{settings.shop_name || SHOP_NAME}</Link>,
              осуществляя регистрацию личного кабинета, производя заказ товара, производя
              оплату за приобретаемые товары, обращаясь за технической поддержкой, а также
              совершая во взаимоотношениях с Оператором любые иные действия в собственных
              интересах, влекущие необходимость в раскрытии персональных данных,
              Пользователь выражает свое добровольное, конкретное, предметное,
              информированное, сознательное и однозначное согласие, которое он дает Оператору
              на обработку своих персональных данных, а также подтверждает ознакомленность и
              согласие с текстом настоящей «Политики в отношении обработки персональных данных».
            </li>
          </ol>
        </li>
      </ol>
    </main>
  );
}

export default PersonalData;
